/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Usage_Tab_Upgrade_Pool_HintInputs */



/**
* | output |
* | --- |
* | "Upgrade to Team for a €{amount}/user token credit pool each billing period" |
*
* @param {Usage_Tab_Upgrade_Pool_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_upgrade_pool_hint = /** @type {((inputs: Usage_Tab_Upgrade_Pool_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Upgrade_Pool_HintInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Upgrade auf Team für ein Token-Guthaben von €${i?.amount}/Nutzer je Abrechnungsperiode`)
	return /** @type {LocalizedString} */ (`Upgrade to Team for a €${i?.amount}/user token credit pool each billing period`)
});